import React from "react";
import { Checkbox } from "antd";

const RenderGrupoHabilidades = ({ grupo, todasSelecionadas, selecionadas, onChange, handleCheckboxChange }) => {
    return (
        <>
            <div style={{ marginBottom: 20 }}>
                <Checkbox
                    checked={todasSelecionadas}
                    indeterminate={selecionadas.length > 0 && !todasSelecionadas}
                    onChange={e => onChange(grupo, e.target.checked)}
                >
                    Selecionar tudo
                </Checkbox>
            </div>
            <div className="bncc-grupo-itens">
                <Checkbox.Group
                    options={grupo.habilidades}
                    value={selecionadas}
                    onChange={sel => handleCheckboxChange(grupo.habilidades, sel)}
                />
            </div>
        </>
    );
};

export default RenderGrupoHabilidades;
